var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.83341H12.2815C13.1559 4.83341 13.8816 5.50916 13.9439 6.38134L14.5391 14.7147C14.6081 15.6794 13.8439 16.5001 12.8767 16.5001H3.1233C2.15606 16.5001 1.39195 15.6794 1.46086 14.7147L2.0561 6.38134C2.1184 5.50916 2.84414 4.83341 3.71853 4.83341H5.5M10.5 4.83341H5.5M10.5 4.83341V3.16675C10.5 1.78604 9.38071 0.666748 8 0.666748C6.61929 0.666748 5.5 1.78604 5.5 3.16675V4.83341M10.4999 9.00008L7.28339 12.2412C7.16135 12.3642 6.96349 12.3642 6.84145 12.2412L5.49992 10.8894",
    stroke: "#7F56D9",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.0e0909136fae3aa66471dedb00ea39c6.svg";
export { ForwardRef as ReactComponent };